function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 700",
    cx: 5,
    cy: 5,
    r: 5,
    style: {
      fill: "#07aa3f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStatus);
export default __webpack_public_path__ + "static/media/activeStatus.dc154eca3dc74e55f4e148b112b90eae.svg";
export { ForwardRef as ReactComponent };